import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { withRouter, Link } from "react-router-dom";
import * as actions from "actions";
import Section from "components/Section";
import ProductCarousel from "components/product";
import ServiceHeader from "components/ServiceHeader";
import ServiceBottom from "components/ServiceBottom";
import Layout from "layout/Layout";
import ReactDOM from 'react-dom';
import CardLayout from "../components/CardLayout";
import moment from "moment";
import DeleteConfirmationModal from "components/DeleteConfirmationModal";
import axios from "services/customer";

class Appointments extends Component {
  state = {
    viewPastAppointment: false,
    modal: false
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView();
    this.props.fetchAllCustomerAppointment();
  }

  componentDidUpdate() {
    this.props.changePageTitle(`Appointments | Vibo Vibo`);
  }

  changeAppointments = () => {
    this.setState(prev => ({viewPastAppointment: !prev.viewPastAppointment}));
  }

  cancelAppointment = id => {
    // (confirm("Are you sure you want to cancel appointment?")) ?  : null;

  }

  showDeleteConfirmationModal = id => {
    this.setState({ modal: true, id: id });
  }

  modalToggle = () => {
    this.setState({ modal: false, id: null });
  }

  handleDeleteServices = () => {
    console.log(this.state.id)
    this.props.cancelCustomerAppointment(this.state.id);
    this.modalToggle();
  }

  render() {
    (function() {
      const token = localStorage.getItem("token");
      if (token) {
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      } else {
        axios.defaults.headers.common.Authorization = null;
        /* if setting null does not remove `Authorization` header then try
            delete axios.defaults.headers.common['Authorization'];
          */
      }
    })();
    let Data = this.state.viewPastAppointment ? this.props.pastAppointment : this.props.upcomingAppointment;
    return (
      <Layout>
        <Helmet>
          <title>{this.props.pageTitle}</title>
        </Helmet>
        <DeleteConfirmationModal
          modal={this.state.modal}
          toggle={this.modalToggle}
          body="vibo.deleteConfirmation.customer.appointment.modal"
          apiDelete={this.handleDeleteServices}
        />
        <div className="m-5 margin-10">
          <div className="col-lg-12"><h1 className="font-mycss">Appointments</h1></div>
          <div className="col-lg-12 mt-2 mb-3">
            <a onClick={this.changeAppointments} style={this.state.viewPastAppointment ? {cursor: 'pointer'}: {color: '#ee0979', fontWeight: 'bold'}}>Upcoming Appointments</a> &nbsp;/&nbsp;
            <a onClick={this.changeAppointments} style={this.state.viewPastAppointment ? {color: '#ee0979', fontWeight: 'bold'}: {cursor: 'pointer'}}>Past Appointments</a></div>
          <div className="col-lg-12">
            <div className="jr-card border-0 pad-10">
              <div className="jr-card-header d-flex align-items-center">
                <div className="mr-auto">
                  <h3 className="d-inline-block mb-0"><span>{this.state.viewPastAppointment ? "Past Appointments" : "Upcoming Appointments"}</span></h3>
                </div>
                <div className="dropdown">
                  </div></div>
                  <div className="table-responsive-material">
                    <table className="default-table table-unbordered table table-sm table-hover">
                      <thead className="th-border-b">
                        <tr>
                          <th>Salon</th>
                          <th>Service</th>
                          <th>Service Provider</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Duration</th>
                          <th>Price</th>
                          
                          {this.state.viewPastAppointment ? null : <th>Status</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {Data.map((item,key) => {
                          return (
                            <tr key={key}>
                              <td>{item.business_slug ? <a onClick={() => {this.props.history.push(`/${item.business_slug}`);}} style={{cursor: 'pointer'}}>{item.businessname}</a> : item.businessname}</td>
                              <td>{item.servicename}</td>
                              <td>{item.employee.firstname + item.employee.lastname}</td>
                              <td>{moment(item.from).format('MM-DD-YYYY')}</td>
                              <td>{moment(item.from).format('hh:mm A')}</td>
                              <td>{`${item.duration} Minutes`}</td>
                              <td>{item.price}</td>
                              {this.state.viewPastAppointment 
                              ? null 
                              : <td>
                                  {item.status == 'canceled' 
                                    ? <label style={{fontWeight: 'bold'}}>Appointment Canceled</label>
                                    : <label id={item._id} onClick={e => this.showDeleteConfirmationModal(e.target.id)} style={{color: '#d81326', cursor: 'pointer', fontWeight: 'bold'}}>Cancel</label>
                                  }
                                </td>
                              }
                            </tr>
                          )
                        })}
                        
                        {/* <tr tabindex="-1">
                          <td>23545</td>
                          <td>
                            <div className="user-profile d-flex flex-row align-items-center">
                                <img alt="Alex Dolgove" src="assets/images/userAvatar/alex-dolgove.png" className="user-avatar rounded-circle mr-3" />
                                <div className="user-detail">
                                  <h5 className="user-name">Alex Dolgove </h5>
                                </div>
                            </div>
                          </td>
                          <td>25 Oct</td>
                          <td>25 Oct</td>
                          <td className="status-cell text-right">
                              <div className=" badge text-uppercase text-white bg-success">Completed</div>
                          </td>
                          <td className="text-right"><span className="icon-btn size-30"><i className="zmdi zmdi-more-vert zmdi-hc-lg"></i></span></td>
                        </tr> */}
                      </tbody>
                    </table>
                      {Data.length != 0 ? null : <h2 className="text-center mt-5 mb-5">You have no {this.state.viewPastAppointment ? 'past' : 'upcoming'} appointments. {this.state.viewPastAppointment ? null :<Link to="/">Book an Appointment Now.</Link>}</h2>}
                  </div>
                </div>
              </div>
              
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = ({ customerAppointment }) => ({
  pastAppointment:customerAppointment.pastAppointment,
  upcomingAppointment:customerAppointment.upcomingAppointment,
});

const mapDispatchToProps = dispatch => ({
  fetchAllCustomerAppointment: () => dispatch(actions.fetchAllCustomerAppointment()),
  changePageTitle: payload => dispatch(actions.setTitleOfPage(payload)),
  cancelCustomerAppointment: payload => dispatch(actions.cancelCustomerAppointment(payload))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Appointments)
);



// WEBPACK FOOTER //
// ./containers/Appointments.js